import { TypeOfMaterial } from '../../../api/elite/types/type-of-material';
import { SchedulerMachine } from '../../../common/scheduler/models/machine';
import { SchedulerSubWorkOrderOnMachine } from '../../../common/scheduler/models/sub-wo-on-machine';
import { FilterSubWorkOrder, FilterWorkOrder } from './item';
import { FiltersWorkOrderOnMachine } from './wo-on-machine';

export class FilterSchedulerMachine extends SchedulerMachine {
  machinesSubWorkOrders: SchedulerSubWorkOrderOnMachine[] = [];
  machinesWorkOrders: FiltersWorkOrderOnMachine[] = [];
  typeOfMaterials: TypeOfMaterial[] = [];

  get machineItems(): (
    | SchedulerSubWorkOrderOnMachine
    | FiltersWorkOrderOnMachine
  )[] {
    return [...this.machinesWorkOrders, ...this.machinesSubWorkOrders];
  }

  static fromObject(object: SchedulerMachine): FilterSchedulerMachine {
    const machine = new FilterSchedulerMachine();
    Object.assign(machine, object);

    machine.machinesWorkOrders =
      machine.machinesWorkOrders.map((machineWorkOrder) => {
        return FiltersWorkOrderOnMachine.fromObject(machineWorkOrder);
      }) || [];

    machine.machinesSubWorkOrders = machine.machinesSubWorkOrders.map(
      (machineSubWorkOrder) => {
        const objClass = new SchedulerSubWorkOrderOnMachine();
        Object.assign(objClass, machineSubWorkOrder);
        objClass.subWorkOrder = FilterSubWorkOrder.fromObject(
          objClass.subWorkOrder as FilterSubWorkOrder
        );
        objClass.subWorkOrder.machinesSubWorkOrders = [objClass];
        return objClass;
      }
    );

    return machine;
  }
}
